import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function BackButton({ className = "" }) {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };
  return (
    <button
      type="button"
      data-testid="back-button"
      onClick={goBack}
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-onSurfaceSecondary hover:text-brand transition-colors mb-5 ${className}`}
    >
      <ArrowLeft size={16} /> Indietro
    </button>
  );
}
